webpackJsonp([1],{

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D9eX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_c('team-logo',{attrs:{"code":_vm.team,"name":_vm.name}},[_c('span',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v("in "+_vm._s(_vm.year))])])],1),_vm._v(" "),_c('table',{staticClass:"table table-condensed"},[_c('tbody',_vm._l((_vm.fixture),function(game){return _c('match',{key:game['.value'],attrs:{"db":_vm.db,"year":_vm.year,"game":game,"selectedTeam":_vm.team,"teams":_vm.teams,"venues":_vm.venues}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DxD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__("lYrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e476121_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__("D9eX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e476121_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FoFp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6g9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__ = __webpack_require__("xUEN");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LadderTeam',
  props: ['team', 'index', 'year', 'selectedTeam'],
  computed: {
    code: function code() {
      return this.team['.key'];
    },
    played: function played() {
      return this.team.won + this.team.drawn + this.team.lost;
    },
    isSelected: function isSelected() {
      return this.code == this.selectedTeam;
    }
  },
  methods: {
    clicked: function clicked() {
      this.$emit('selected', this.code);
    }
  },
  components: {
    TeamLogo: __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "IABT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KDMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{style:(_vm.resultStyle)},[_c('td',{staticClass:"round"},[_vm._v(_vm._s(_vm.game.name))]),_vm._v(" "),_c('td',[_c('team-logo',{attrs:{"code":_vm.oppCode,"name":_vm.oppName,"position":"right"}},[_c('span',{attrs:{"slot":"prefix"},slot:"prefix"},[_vm._v(_vm._s(_vm.result)+"\n        "),_c('span',{class:{ isUs: _vm.isHome }},[_vm._v(_vm._s(this.game.home.score))]),_vm._v("\n        -\n        "),_c('span',{class:{ isUs: !_vm.isHome }},[_vm._v(_vm._s(this.game.away.score))]),_vm._v("\n        "+_vm._s(_vm.location))])])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.venue))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44db67e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("tuIK");
function injectStyle (ssrContext) {
  __webpack_require__("ofMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44db67e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "OGXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LadderHeader_vue__ = __webpack_require__("ZcIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265e49da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LadderHeader_vue__ = __webpack_require__("yhZO");
function injectStyle (ssrContext) {
  __webpack_require__("FoFp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-265e49da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LadderHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265e49da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LadderHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QIrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Match_vue__ = __webpack_require__("Z3z0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6750d69e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Match_vue__ = __webpack_require__("KDMs");
function injectStyle (ssrContext) {
  __webpack_require__("UhXJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Match_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6750d69e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Match_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QpMc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R9qJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RtBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LadderTeam',
  props: ['code', 'name'],
  computed: {
    style: function style() {
      return { backgroundImage: 'url(\'/static/' + this.code + '.png\')' };
    }
  }
});

/***/ }),

/***/ "TAMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LadderTeam_vue__ = __webpack_require__("G6g9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0f7d33a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LadderTeam_vue__ = __webpack_require__("ov5w");
function injectStyle (ssrContext) {
  __webpack_require__("QpMc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LadderTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0f7d33a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LadderTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UahP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.year)+" AFL Ladder")]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-condensed table-responsive"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('ladder-header',{key:column.column,attrs:{"column":column.column,"title":column.title,"defaultOrder":column.defaultOrder},on:{"sort":_vm.sortBy}})}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.teams),function(team,index){return _c('ladder-team',{key:team.key,attrs:{"team":team,"index":index,"year":_vm.year,"selectedTeam":_vm.selectedTeam},on:{"selected":_vm.selected}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UhXJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z3z0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__ = __webpack_require__("xUEN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Match',
  props: ['db', 'year', 'game', 'selectedTeam', 'teams', 'venues'],
  data: function data() {
    return {
      oppCode: null,
      oppName: null,
      venue: null,
      location: null,
      result: null,
      isHome: true,
      resultStyle: {}
    };
  },
  methods: {
    calculateResult: function calculateResult(score, against) {
      if (score > against) {
        this.result = 'Won';
        this.resultStyle.backgroundColor = '#cfc';
      } else if (score < against) {
        this.result = 'Lost';
        this.resultStyle.backgroundColor = '#fcc';
      } else {
        this.result = 'Drawn';
        this.resultStyle.backgroundColor = '#eee';
      }
    }
  },
  mounted: function mounted() {
    var opp = null;
    if (this.game.home.team == this.selectedTeam) {
      this.oppCode = this.game.away.team;
      this.location = 'vs';
      this.isHome = true;
      this.calculateResult(this.game.home.score, this.game.away.score);
    } else {
      this.oppCode = this.game.home.team;
      this.location = 'at';
      this.isHome = false;
      this.calculateResult(this.game.away.score, this.game.home.score);
    }
    this.oppName = this.teams[this.oppCode].name;
    this.venue = this.venues['v' + this.game.venue].name;
  },
  components: {
    TeamLogo: __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "ZcIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LadderHeader',
  props: ['column', 'title', 'defaultOrder'],
  methods: {
    sort: function sort() {
      this.$emit('sort', this.column, this.defaultOrder);
    }
  }
});

/***/ }),

/***/ "crDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo",style:(_vm.style)},[_vm._t("prefix"),_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),_vm._t("suffix")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dQeO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ladder_vue__ = __webpack_require__("mgfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa3fd66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ladder_vue__ = __webpack_require__("UahP");
function injectStyle (ssrContext) {
  __webpack_require__("IABT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fa3fd66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ladder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa3fd66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ladder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lYrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__ = __webpack_require__("xUEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Match_vue__ = __webpack_require__("QIrS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Team',
  props: ['db', 'team', 'year', 'teams', 'venues'],
  data: function data() {
    return {
      fixture: null,
      name: null
    };
  },
  methods: {
    update: function update() {
      if (!this.team || !this.year) {
        return;
      }
      this.$bindAsArray('fixture', this.db.ref('results').child(this.team).child(this.year));
      this.name = this.teams[this.team].name;
    }
  },
  watch: {
    team: function team(val) {
      this.update();
    },
    year: function year(val) {
      this.update();
    }
  },
  mounted: function mounted() {
    this.update();
  },
  components: {
    TeamLogo: __WEBPACK_IMPORTED_MODULE_0__TeamLogo_vue__["a" /* default */],
    Match: __WEBPACK_IMPORTED_MODULE_1__Match_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "mgfN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LadderHeader_vue__ = __webpack_require__("OGXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LadderTeam_vue__ = __webpack_require__("TAMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Ladder',
  props: ['data', 'year'],
  components: {
    LadderHeader: __WEBPACK_IMPORTED_MODULE_0__LadderHeader_vue__["a" /* default */],
    LadderTeam: __WEBPACK_IMPORTED_MODULE_1__LadderTeam_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTeam: null,
      sortKey: ['points', 'percentage'],
      sortOrder: ['desc', 'desc'],
      reverse: false,
      columns: [{ column: "name", title: "Club", defaultOrder: "asc" }, { column: "played", title: "Played", defaultOrder: "desc" }, { column: "won", title: "Won", defaultOrder: "desc" }, { column: "drawn", title: "Drawn", defaultOrder: "desc" }, { column: "lost", title: "Lost", defaultOrder: "desc" }, { column: "points", title: "Points", defaultOrder: "desc" }, { column: "percentage", title: "%", defaultOrder: "desc" }]
    };
  },
  computed: {
    teams: function teams() {
      var teams = _.orderBy(this.data, this.sortKey, this.sortOrder);
      for (var i = 0, len = teams.length; i < len; i++) {
        teams[i].index = i;
      }
      return teams;
    }
  },
  methods: {
    sortBy: function sortBy(sortKey, sortOrder) {
      if (this.sortKey[0] == sortKey && this.sortOrder[0] == 'asc') {
        this.sortOrder = ['desc', 'asc'];
      } else if (this.sortKey[0] == sortKey && this.sortOrder[0] == 'desc') {
        this.sortOrder = ['asc', 'asc'];
      } else {
        this.sortKey = [sortKey, 'index'];
        this.sortOrder = [sortOrder, 'asc'];
      }
    },
    selected: function selected(teamCode) {
      this.selectedTeam = teamCode;
      this.$emit('selected', teamCode);
    }
  }
});

/***/ }),

/***/ "ofMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ov5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{ selected: _vm.isSelected },on:{"click":_vm.clicked}},[_c('td',[_c('team-logo',{attrs:{"code":_vm.code,"name":_vm.team.name}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.played))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.team.won))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.team.drawn))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.team.lost))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.team.points))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.team.percentage))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tuIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.years),function(y){return _c('option',[_vm._v(_vm._s(y))])})),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('ladder',{attrs:{"data":_vm.ladder,"year":_vm.year},on:{"selected":_vm.selected}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6"},[(_vm.team)?_c('team',{attrs:{"db":_vm.database,"year":_vm.year,"team":_vm.team,"teams":_vm.teams,"venues":_vm.venues}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ladder_vue__ = __webpack_require__("dQeO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Team_vue__ = __webpack_require__("DxD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var app = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyBYz8wVT4s1-cdLhlNN7SZmCZdMWwTVgtQ',
  authDomain: 'centre-square.firebaseapp.com',
  databaseURL: 'https://centre-square.firebaseio.com',
  projectId: 'centre-square',
  storageBucket: 'centre-square.appspot.com',
  messagingSenderId: '1027942665805'
});
var db = app.database();
var ladders = db.ref('ladders');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  firebase: function firebase() {
    return {
      range: { source: db.ref('range'), asObject: true },
      ladder: ladders.child(this.year),
      teams: { source: db.ref('teams'), asObject: true },
      venues: { source: db.ref('venues'), asObject: true }
    };
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      team: null
    };
  },
  methods: {
    selected: function selected(teamCode) {
      this.team = teamCode;
    }
  },
  computed: {
    years: function years() {
      var _this = this;

      if (!this.range.start) {
        return new Array();
      }
      return new Array(this.range.end + 1 - this.range.start).fill().map(function (d, i) {
        return i + _this.range.start;
      }).reverse();
    },
    database: function database() {
      return db;
    }
  },
  watch: {
    year: function year(val) {
      this.$bindAsArray('ladder', ladders.child(val));
    }
  },
  components: {
    Ladder: __WEBPACK_IMPORTED_MODULE_0__Ladder_vue__["a" /* default */],
    Team: __WEBPACK_IMPORTED_MODULE_1__Team_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "xUEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLogo_vue__ = __webpack_require__("RtBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3515e28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLogo_vue__ = __webpack_require__("crDr");
function injectStyle (ssrContext) {
  __webpack_require__("R9qJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3515e28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yhZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{on:{"click":_vm.sort}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.46de1a213a0ae525a316.js